module.exports = __webpack_public_path__ + "img/sebastian-hagens-4@2x.7ecb0f67.jpg";